import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';

interface AntSwitchProps extends SwitchProps {
  width?: number;
  height?: number;
  thumbWidth?: number;
  thumbHeight?: number;
}

const AntSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== 'width' && prop !== 'height',
})<AntSwitchProps>(
  ({ theme, width = 42, height = 23, thumbWidth = 20, thumbHeight = 18 }) => ({
    width,
    height,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#1976d2',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#1976d2',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: thumbWidth,
      height: thumbHeight,
    },
    '& .MuiSwitch-track': {
      borderRadius: height / 2,
      backgroundColor: '#9f9fa4',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }),
);

export default function CustomizedSwitches(props: any) {
  const {
    is_checked,
    onChange,
    disabled = false,
    width = 42,
    height = 23,
    thumbWidth = 20,
    thumbHeight = 18,
  } = props;
  return (
    <AntSwitch
      checked={is_checked}
      onChange={onChange}
      disabled={disabled}
      width={width}
      height={height}
      thumbWidth={thumbWidth}
      thumbHeight={thumbHeight}
    />
  );
}
